import { render, staticRenderFns } from "./BookByQr.vue?vue&type=template&id=64b4d5d0"
import script from "./BookByQr.vue?vue&type=script&lang=js"
export * from "./BookByQr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports